import { Extension } from '@tiptap/core';

/**
 * FontSizeExtension — adds font-size support via TextStyle mark.
 * Usage: editor.chain().focus().setFontSize('14px').run()
 *        editor.chain().focus().setFontSize(null).run()  // reset
 */
export const FontSizeExtension = Extension.create({
    name: 'fontSize',

    addOptions() {
        return { types: ['textStyle'] };
    },

    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    fontSize: {
                        default: null,
                        parseHTML: (el) => el.style.fontSize || null,
                        renderHTML: (attrs) =>
                            attrs.fontSize ? { style: `font-size: ${attrs.fontSize}` } : {},
                    },
                },
            },
        ];
    },

    addCommands() {
        return {
            /**
             * Set font size on the current selection.
             * @param {string|null} size - e.g. '14px', or null to clear
             */
            setFontSize:
                (size) =>
                ({ chain }) =>
                    chain()
                        .setMark('textStyle', { fontSize: size || null })
                        .run(),
        };
    },
});
